export const regions = {
  CA: [
    { label: 'Alberta', value: 'AB' },
    { label: 'British Columbia', value: 'BC' },
    { label: 'Manitoba', value: 'MB' },
    { label: 'New Brunswick', value: 'NB' },
    { label: 'Newfoundland and Labrador', value: 'NL' },
    { label: 'Northwest Territories', value: 'NT' },
    { label: 'Nova Scotia', value: 'NS' },
    { label: 'Nunavut', value: 'NU' },
    { label: 'Ontario', value: 'ON' },
    { label: 'Prince Edward Island', value: 'PE' },
    { label: 'Quebec', value: 'QC' },
    { label: 'Saskatchewan', value: 'SK' },
    { label: 'Yukon', value: 'YT' }
  ],
  US: [
    { label: 'Alabama', value: 'AL' },
    { label: 'Alaska', value: 'AK' },
    { label: 'Arizona', value: 'AZ' },
    { label: 'Arkansas', value: 'AR' },
    { label: 'California', value: 'CA' },
    { label: 'Colorado', value: 'CO' },
    { label: 'Connecticut', value: 'CT' },
    { label: 'Delaware', value: 'DE' },
    { label: 'District of Columbia', value: 'DC' },
    { label: 'Florida', value: 'FL' },
    { label: 'Georgia', value: 'GA' },
    { label: 'Hawaii', value: 'HI' },
    { label: 'Idaho', value: 'ID' },
    { label: 'Illinois', value: 'IL' },
    { label: 'Indiana', value: 'IN' },
    { label: 'Iowa', value: 'IA' },
    { label: 'Kansas', value: 'KS' },
    { label: 'Kentucky', value: 'KY' },
    { label: 'Louisiana', value: 'LA' },
    { label: 'Maine', value: 'ME' },
    { label: 'Maryland', value: 'MD' },
    { label: 'Massachusetts', value: 'MA' },
    { label: 'Michigan', value: 'MI' },
    { label: 'Minnesota', value: 'MN' },
    { label: 'Mississippi', value: 'MS' },
    { label: 'Missouri', value: 'MO' },
    { label: 'Montana', value: 'MT' },
    { label: 'Nebraska', value: 'NE' },
    { label: 'Nevada', value: 'NV' },
    { label: 'New Hampshire', value: 'NH' },
    { label: 'New Jersey', value: 'NJ' },
    { label: 'New Mexico', value: 'NM' },
    { label: 'New York', value: 'NY' },
    { label: 'North Carolina', value: 'NC' },
    { label: 'North Dakota', value: 'ND' },
    { label: 'Ohio', value: 'OH' },
    { label: 'Oklahoma', value: 'OK' },
    { label: 'Oregon', value: 'OR' },
    { label: 'Pennsylvania', value: 'PA' },
    { label: 'Rhode Island', value: 'RI' },
    { label: 'South Carolina', value: 'SC' },
    { label: 'South Dakota', value: 'SD' },
    { label: 'Tennessee', value: 'TN' },
    { label: 'Texas', value: 'TX' },
    { label: 'Utah', value: 'UT' },
    { label: 'Vermont', value: 'VT' },
    { label: 'Virginia', value: 'VA' },
    { label: 'Washington', value: 'WA' },
    { label: 'West Virginia', value: 'WV' },
    { label: 'Wisconsin', value: 'WI' },
    { label: 'Wyoming', value: 'WY' },
    { label: 'American Samoa', value: 'AS' },
    { label: 'Guam', value: 'GU' },
    { label: 'Northern Mariana Islands', value: 'MP' },
    { label: 'Puerto Rico', value: 'PR' },
    { label: 'U.S. Virgin Islands', value: 'VI' }
  ]
};

export const applicationCooldownHours = 48;

export const apiPerPage = process.env.API_PERPAGE || 40;
export const validationDisabled =
  process.env.NEXT_PUBLIC_DISABLE_VALIDATION === 'true';

export const providerNames = {
  google: 'Google',
  apple: 'Apple',
  twitter: 'X',
  facebook: 'Facebook'
};

export const MailConfig = {
  from: process.env.MAIL_FROM || 'Beautifi <noreply@beautifi.com>',
  partnerships:
    process.env.MAIL_PARTNERSHIPS ||
    'Beautifi Partnerships <partnerships@beautifi.com>',
  funding: process.env.MAIL_FUNDING || 'Beautifi Funding <funding@beautifi.com>'
};

export const springUrl =
  process.env.SPRING_URL ||
  'https://www.springfinancial.ca/apply/personal-loans?SID=beautifi&utm_source=beautifi&utm_medium=affiliates&utm_campaign=beautifi&AID=beautifi';

/*
This allows the values here to be picekd up by the translator
t('global.regions.canada.AB', 'Alberta');
t('global.regions.canada.BC', 'British Columbia');
t('global.regions.canada.MB', 'Manitoba');
t('global.regions.canada.NB', 'New Brunswick');
t('global.regions.canada.NL', 'Newfoundland and Labrador');
t('global.regions.canada.NT', 'Northwest Territories');
t('global.regions.canada.NS', 'Nova Scotia');
t('global.regions.canada.NU', 'Nunavut');
t('global.regions.canada.ON', 'Ontario');
t('global.regions.canada.PE', 'Prince Edward Island');
t('global.regions.canada.QC', 'Quebec');
t('global.regions.canada.SK', 'Saskatchewan');
t('global.regions.canada.YT', 'Yukon');
t('global.regions.usa.AL', 'Alabama');
t('global.regions.usa.AK', 'Alaska');
t('global.regions.usa.AZ', 'Arizona');
t('global.regions.usa.AR', 'Arkansas');
t('global.regions.usa.CA', 'California');
t('global.regions.usa.CO', 'Colorado');
t('global.regions.usa.CT', 'Connecticut');
t('global.regions.usa.DE', 'Delaware');
t('global.regions.usa.DC', 'District of Columbia');
t('global.regions.usa.FL', 'Florida');
t('global.regions.usa.GA', 'Georgia');
t('global.regions.usa.HI', 'Hawaii');
t('global.regions.usa.ID', 'Idaho');
t('global.regions.usa.IL', 'Illinois');
t('global.regions.usa.IN', 'Indiana');
t('global.regions.usa.IA', 'Iowa');
t('global.regions.usa.KS', 'Kansas');
t('global.regions.usa.KY', 'Kentucky');
t('global.regions.usa.LA', 'Louisiana');
t('global.regions.usa.ME', 'Maine');
t('global.regions.usa.MD', 'Maryland');
t('global.regions.usa.MA', 'Massachusetts');
t('global.regions.usa.MI', 'Michigan');
t('global.regions.usa.MN', 'Minnesota');
t('global.regions.usa.MS', 'Mississippi');
t('global.regions.usa.MO', 'Missouri');
t('global.regions.usa.MT', 'Montana');
t('global.regions.usa.NE', 'Nebraska');
t('global.regions.usa.NV', 'Nevada');
t('global.regions.usa.NH', 'New Hampshire');
t('global.regions.usa.NJ', 'New Jersey');
t('global.regions.usa.NM', 'New Mexico');
t('global.regions.usa.NY', 'New York');
t('global.regions.usa.NC', 'North Carolina');
t('global.regions.usa.ND', 'North Dakota');
t('global.regions.usa.OH', 'Ohio');
t('global.regions.usa.OK', 'Oklahoma');
t('global.regions.usa.OR', 'Oregon');
t('global.regions.usa.PA', 'Pennsylvania');
t('global.regions.usa.RI', 'Rhode Island');
t('global.regions.usa.SC', 'South Carolina');
t('global.regions.usa.SD', 'South Dakota');
t('global.regions.usa.TN', 'Tennessee');
t('global.regions.usa.TX', 'Texas');
t('global.regions.usa.UT', 'Utah');
t('global.regions.usa.VT', 'Vermont');
t('global.regions.usa.VA', 'Virginia');
t('global.regions.usa.WA', 'Washington');
t('global.regions.usa.WV', 'West Virginia');
t('global.regions.usa.WI', 'Wisconsin');
t('global.regions.usa.WY', 'Wyoming');
t('global.regions.usa.AS', 'American Samoa');
t('global.regions.usa.GU', 'Guam');
t('global.regions.usa.MP', 'Northern Mariana Islands');
t('global.regions.usa.PR', 'Puerto Rico');
t('global.regions.usa.VI', 'U.S. Virgin Islands');
*/

/*
This allows the values here to be picked up by the translator
t('offersTable.tag.zeroInterest', '0% Interest');
t('offersTable.tag.discounted', 'Discounted Interest');
t('offersTable.tag.lowestPayment', 'Lowest Payment');
t('offersTable.tag.mostPopular', 'Most Popular');
t('offersTable.tag.lowestRate', 'Lowest Rate');
*/

export const loanMinAmount = 1000;
export const loanDefaultAmount = 7500;
export const loanMaxAmount = 50000;

export const resultExpireHours = 48;

export const stepStorageKey = 'current-step';
export const finalizeStepStorageKey = 'finalize-step';
export const checkoutStepStorageKey = 'checkout-step';

// Amount of time to wait for Salesforce to convert the lead after signing
export const conversionDelay = 2000;

/**
 * Standard max-width and horizontal padding for form/content areas.
 * Change max-width in tailwind.config.js (theme.extend.maxWidth['form-content']).
 */
export const formContentBaseStyle = 'max-w-form-content w-full mx-auto';

/**
 * Single canonical layout for application form step content.
 * Use as the root wrapper in each form step component for uniform spacing and width.
 */
export const formStepRootClass = 'flex flex-col gap-4 w-full';

/**
 * Root of an application screen: heading, step content and FormActions rhythm.
 */
export const formScreenRootClass = 'flex flex-col gap-8';

// Should match SalesForce's email address rules
export const emailValidation =
  "^(?=(?:\\([^)]*\\))*[^()\\n]+[^@\\n]*@)(?!(?:\\([^)]*\\))*\\.)(?:(?:[\\w!#$%&'*+/=?^`{|}~.-]|\\([\\w!#$%&'*+/=?^`{|}~.-]*\\))+|\"(?:[\\w!#$%&'*+/=?^`{|}~.-]|\\([\\w!#$%&'*+/=?^`{|}~.-]*\\))*\")@(?:\\([A-Za-z0-9-]*\\))*(?:[A-Za-z0-9]+(?:(?:\\([A-Za-z0-9-]*\\))*-(?:\\([A-Za-z0-9-]*\\))*[A-Za-z0-9]+)*(?:\\([A-Za-z0-9-]*\\))*)(?:\\.(?:\\([A-Za-z0-9-]*\\))*(?:[A-Za-z0-9]+(?:(?:\\([A-Za-z0-9-]*\\))*-(?:\\([A-Za-z0-9-]*\\))*[A-Za-z0-9]+)*(?:\\([A-Za-z0-9-]*\\))*))+$";

export const maxHistoryAgeMonths = 6;
export const activityEventType = {
  SignIn: 'signin',
  View: 'view',
  Edit: 'edit',
  Delete: 'delete',
  Action: 'action',
  Misc: 'misc'
};

export const formPages = [
  {
    id: 'personal',
    name: 'Personal',
    sortable: true,
    pages: ['personal']
  },
  {
    id: 'address',
    name: 'Home Address',
    sortable: true,
    pages: ['address']
  },
  {
    id: 'loan-details',
    name: 'Loan Details',
    sortable: true,
    pages: ['loan-details']
  },
  {
    id: 'income',
    name: 'Income Details',
    sortable: true,
    pages: ['employment', 'income', 'additional-income']
  },
  {
    id: 'rent',
    name: 'Mortgage/Rent',
    sortable: true,
    pages: ['residence']
  },
  {
    id: 'procedure',
    name: 'Procedure Details',
    sortable: true,
    pages: ['procedure']
  },
  {
    id: 'provider',
    name: 'Provider Details',
    sortable: true,
    pages: ['doctor']
  }
];

export const partnerFormPages = [
  {
    id: 'personal',
    name: 'Personal',
    sortable: true,
    pages: ['personal']
  },
  {
    id: 'income',
    name: 'Income Details',
    sortable: true,
    pages: ['employment', 'income', 'additional-income']
  },
  {
    id: 'rent',
    name: 'Mortgage/Rent',
    sortable: true,
    pages: ['residence']
  }
];

export const agreementCurrencyFields = [
  'approvedPaymentAmount',
  'baseLoanAmount',
  'lenderAmountFee',
  'maximumApproval',
  'monthlyPaymentTotal',
  'nonInterestCharges',
  'principalAmount',
  'totalCostOfBorrowing',
  'totalFeeAmount',
  'totalInterestPaid',
  'totalObligationOfCustomer',
  'totalOfCreditCharges',
  'upfrontFeeAmount'
];

export const docusignCurrencyFields = [
  'approvedPaymentAmount',
  'baseLoanAmount',
  'lenderAmountFee',
  'principalAmount',
  'totalFeeAmount',
  'totalInterestPaid',
  'totalObligationOfCustomer',
  'totalOfCreditCharges'
];

export const streetTypes = [
  'abbey',
  'acres',
  'allee',
  'allée',
  'alley',
  'ally',
  'aly',
  'anex',
  'annex',
  'annx',
  'anx',
  'arc',
  'arcade',
  'aut',
  'autoroute',
  'av',
  'ave',
  'aven',
  'avenida',
  'avenu',
  'avenue',
  'avn',
  'avnue',
  'bay',
  'bayoo',
  'bayou',
  'bch',
  'beach',
  'bend',
  'bg',
  'bgs',
  'bld',
  'blf',
  'blfs',
  'bluf',
  'bluff',
  'bluffs',
  'blv',
  'blvd',
  'bnd',
  'bot',
  'bottm',
  'bottom',
  'boul',
  'boulevard',
  'boulv',
  'br',
  'branch',
  'brdge',
  'brg',
  'bridge',
  'brk',
  'brks',
  'brnch',
  'brook',
  'brooks',
  'btm',
  'burg',
  'burgs',
  'by-pass',
  'byp',
  'bypa',
  'bypas',
  'bypass',
  'byps',
  'byu',
  'byway',
  'c',
  'calle',
  'camino',
  'camp',
  'campus',
  'canyn',
  'canyon',
  'cape',
  'car',
  'carré',
  'carref',
  'carrefour',
  'causeway',
  'causwa',
  'cds',
  'cen',
  'cent',
  'center',
  'centers',
  'centr',
  'centre',
  'cercle',
  'ch',
  'chase',
  'chemin',
  'cir',
  'circ',
  'circl',
  'circle',
  'circles',
  'circt',
  'circuit',
  'cirs',
  'clb',
  'clf',
  'clfs',
  'cliff',
  'cliffs',
  'close',
  'club',
  'cmn',
  'cmns',
  'cmp',
  'cnter',
  'cntr',
  'cnyn',
  'common',
  'commons',
  'conc',
  'concession',
  'cor',
  'corner',
  'corners',
  'cors',
  'côte',
  'cour',
  'course',
  'court',
  'courts',
  'cove',
  'coves',
  'cp',
  'cpe',
  'crcl',
  'crcle',
  'creek',
  'cres',
  'crescent',
  'crest',
  'crk',
  'crnrs',
  'crois',
  'croissant',
  'cross',
  'crossing',
  'crossroad',
  'crse',
  'crsent',
  'crsnt',
  'crssng',
  'crst',
  'crt',
  'cswy',
  'ct',
  'ctr',
  'ctrs',
  'cts',
  'cul-de-sac',
  'curv',
  'curve',
  'cv',
  'cvs',
  'cyn',
  'dale',
  'dam',
  'dell',
  'div',
  'divers',
  'diversion',
  'divide',
  'dl',
  'dm',
  'downs',
  'dr',
  'driv',
  'drive',
  'drives',
  'drs',
  'drv',
  'dv',
  'dvd',
  'éch',
  'échangeur',
  'end',
  'espl',
  'esplanada',
  'est',
  'estate',
  'estates',
  'ests',
  'exp',
  'expr',
  'express',
  'expressway',
  'expw',
  'expwy',
  'expy',
  'ext',
  'exten',
  'extension',
  'extensions',
  'extn',
  'extnsn',
  'exts',
  'fall',
  'falls',
  'farm',
  'ferry',
  'field',
  'fields',
  'flat',
  'flats',
  'fld',
  'flds',
  'fls',
  'flt',
  'flts',
  'ford',
  'fords',
  'forest',
  'forg',
  'forge',
  'forges',
  'fork',
  'forks',
  'fort',
  'frd',
  'frds',
  'freeway',
  'freewy',
  'frg',
  'frgs',
  'frk',
  'frks',
  'front',
  'frry',
  'frst',
  'frt',
  'frway',
  'frwy',
  'fry',
  'ft',
  'fwy',
  'garden',
  'gardens',
  'gardn',
  'gate',
  'gateway',
  'gatewy',
  'gatway',
  'gdn',
  'gdns',
  'glade',
  'glen',
  'glens',
  'gln',
  'glns',
  'grden',
  'grdn',
  'green',
  'greens',
  'grn',
  'grnds',
  'grns',
  'grounds',
  'grov',
  'grove',
  'groves',
  'grv',
  'grvs',
  'gtway',
  'gtwy',
  'harb',
  'harbor',
  'harbors',
  'harbour',
  'harbr',
  'haven',
  'hbr',
  'hbrs',
  'heights',
  'hghlds',
  'highlands',
  'highway',
  'highwy',
  'hill',
  'hills',
  'hiway',
  'hiwy',
  'hl',
  'hllw',
  'hls',
  'hollow',
  'holw',
  'holws',
  'hrbor',
  'hts',
  'hvn',
  'hway',
  'hwy',
  'île',
  'imp',
  'impasse',
  'inlet',
  'inlt',
  'is',
  'island',
  'islands',
  'isle',
  'iss',
  'jct',
  'jction',
  'jctn',
  'jcts',
  'junction',
  'junctions',
  'junctn',
  'juncton',
  'key',
  'keys',
  'knl',
  'knls',
  'knol',
  'knoll',
  'knolls',
  'ky',
  'kys',
  'la',
  'lake',
  'lakes',
  'land',
  'landing',
  'landng',
  'lane',
  'lck',
  'lcks',
  'ldg',
  'ldge',
  'lf',
  'lgt',
  'lgts',
  'light',
  'lights',
  'limits',
  'line',
  'link',
  'lk',
  'lkout',
  'lks',
  'lmts',
  'ln',
  'lndg',
  'lndng',
  'loaf',
  'lock',
  'locks',
  'lodg',
  'lodge',
  'lookout',
  'loop',
  'lp',
  'mall',
  'manor',
  'manors',
  'maze',
  'mdw',
  'mdws',
  'meadow',
  'meadows',
  'medows',
  'mews',
  'mill',
  'mills',
  'mission',
  'ml',
  'mls',
  'mnr',
  'mnrs',
  'montée',
  'moor',
  'motorway',
  'mount',
  'mountain',
  'mountains',
  'msn',
  'mt',
  'mtn',
  'mtns',
  'mtwy',
  'nck',
  'neck',
  'opas',
  'orch',
  'orchard',
  'orchrd',
  'oval',
  'overlook',
  'overpass',
  'ovl',
  'ovlk',
  'parade',
  'parc',
  'park',
  'parks',
  'parkway',
  'parkways',
  'parkwy',
  'pass',
  'passage',
  'path',
  'pathway',
  'pike',
  'pine',
  'pines',
  'pk',
  'pkway',
  'pkwy',
  'pkwys',
  'pky',
  'pl',
  'place',
  'plain',
  'plains',
  'plat',
  'plateau',
  'plaza',
  'pln',
  'plns',
  'plz',
  'plza',
  'pne',
  'pnes',
  'point',
  'points',
  'port',
  'ports',
  'pr',
  'prairie',
  'private',
  'prk',
  'prom',
  'promenade',
  'prr',
  'prt',
  'prts',
  'psge',
  'pt',
  'pts',
  'ptway',
  'pvt',
  'quai',
  'quay',
  'rad',
  'radial',
  'radiel',
  'radl',
  'ramp',
  'ranch',
  'rang',
  'range',
  'rapid',
  'rapids',
  'rd',
  'rdg',
  'rdge',
  'rdgs',
  'rdpt',
  'rds',
  'rest',
  'rg',
  'ridge',
  'ridges',
  'rise',
  'riv',
  'river',
  'rivr',
  'rle',
  'rmp',
  'rnch',
  'rnchs',
  'road',
  'roads',
  'rond point',
  'route',
  'row',
  'rpd',
  'rpds',
  'rst',
  'rte',
  'rue',
  'ruelle',
  'run',
  'rvr',
  'sent',
  'sentier',
  'shl',
  'shls',
  'shoal',
  'shoals',
  'shore',
  'shores',
  'shr',
  'shrs',
  'skwy',
  'skyway',
  'smt',
  'spg',
  'spgs',
  'spng',
  'spring',
  'springs',
  'sprng',
  'spur',
  'sq',
  'sqr',
  'sqre',
  'sqs',
  'squ',
  'square',
  'squares',
  'st',
  'sta',
  'station',
  'statn',
  'stn',
  'str',
  'stream',
  'street',
  'streets',
  'streme',
  'strm',
  'strt',
  'sts',
  'subdiv',
  'subdivision',
  'sumit',
  'sumitt',
  'summit',
  'ter',
  'terr',
  'terrace',
  'terrasse',
  'thick',
  'thicket',
  'throughway',
  'tline',
  'towers',
  'townline',
  'tpke',
  'trace',
  'track',
  'trafficway',
  'trail',
  'trailer',
  'trak',
  'trce',
  'trfy',
  'trk',
  'trks',
  'trl',
  'trlr',
  'trnabt',
  'trnpk',
  'trwy',
  'tsse',
  'tunl',
  'tunnel',
  'turnabout',
  'turnpike',
  'turnpk',
  'un',
  'underpass',
  'union',
  'unions',
  'uns',
  'upas',
  'vale',
  'valley',
  'valleys',
  'vally',
  'vdct',
  'via',
  'viadct',
  'viaduct',
  'view',
  'views',
  'vill',
  'villag',
  'village',
  'villages',
  'ville',
  'villg',
  'villge',
  'vis',
  'vist',
  'vista',
  'vl',
  'vlg',
  'vlgs',
  'vlly',
  'vly',
  'vlys',
  'voie',
  'vst',
  'vsta',
  'vw',
  'vws',
  'walk',
  'wall',
  'way',
  'well',
  'wells',
  'wharf',
  'wl',
  'wls',
  'wood',
  'wy',
  'wynd',
  'xing',
  'xrd'
];

// ── Device / Equipment Financing ────────────────────────────────────────

export const deviceFinancingStepStorageKey = 'device-financing-step';
export const deviceFinancingUtmStorageKey = 'device-financing-utm';

export const deviceFinancingUtmKeys = [
  'utm_campaign',
  'utm_id',
  'campaignid',
  'utm_source',
  'utm_medium',
  'utm_content',
  'utm_term'
];

export const deviceFinancingEquipmentCategories = [
  { label: '4K Arthroscope', value: '4K Arthroscope' },
  { label: 'Accent Prime', value: 'Accent Prime' },
  { label: 'AccuTite', value: 'AccuTite' },
  { label: 'Aliya', value: 'Aliya' },
  { label: 'Alma Hybrid', value: 'Alma Hybrid' },
  { label: 'BeautiFill', value: 'BeautiFill' }
];

export const deviceFinancingAnnualSalesOptions = [
  { label: 'Under $250,000', value: 'Under $250,000' },
  { label: '$250,000-$500,000', value: '$250,000-$500,000' },
  { label: '$500,000-$1,000,000', value: '$500,000-$1,000,000' },
  { label: '$1 Million - $2.5 Million', value: '$1 Million - $2.5 Million' },
  { label: '$2.5 Million - $5 Million', value: '$2.5 Million - $5 Million' },
  { label: '$5 Million - $10 Million', value: '$5 Million - $10 Million' },
  { label: '$10 Million or More', value: '$10 Million or More' },
  { label: 'Not Sure', value: 'Not Sure' }
];

export const deviceFinancingEntityTypes = [
  { label: 'Corporation', value: 'Corporation' },
  { label: 'LLC', value: 'LLC' },
  { label: 'Sole proprietorship', value: 'Sole proprietorship' },
  { label: 'Partnership', value: 'Partnership' },
  { label: 'Other', value: 'Other' }
];

export const deviceFinancingMaritalStatusOptions = [
  { label: 'Single', value: 'Single' },
  { label: 'Married', value: 'Married' },
  { label: 'Common-Law', value: 'Common-Law' },
  { label: 'Divorced', value: 'Divorced' },
  { label: 'Other', value: 'Other' }
];

export const deviceFinancingYesNoOptions = [
  { label: 'Yes', value: 'yes' },
  { label: 'No', value: 'no' }
];

export const deviceFinancingBusinessIndustryOptions = [
  { label: 'Cosmetic', value: 'Cosmetic' },
  { label: 'Dental', value: 'Dental' },
  { label: 'Fertility', value: 'Fertility' },
  { label: 'Optometry', value: 'Optometry' },
  { label: 'Surgical', value: 'Surgical' },
  { label: 'Tattoo', value: 'Tattoo' },
  { label: 'Other', value: 'Other' }
];

export const deviceFinancingDocuSignTemplateName =
  process.env.DEVICE_FINANCING_DOCUSIGN_TEMPLATE_NAME ||
  'Business_Financing_Application';

export const deviceFinancingDocuSignTemplateId =
  process.env.DEVICE_FINANCING_DOCUSIGN_TEMPLATE_ID || null;
